const emojiCloudSnapshot = {
    id: 'cGFuZWw6NWQ4YzUxNWIzNWJmMjcwZmVlODUwYjQx',
    partnerId: 349,
    clientId: 7101,
    name: 'Emoji Cloud',
    description: '',
    publishTier: 'ZERO',
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: null,
                contrast: null,
            },
        },
    },
    storyboard: {
        id: 'c3Rvcnlib2FyZDo1ZDhhOTIzODM1YmYyNzA5MDNiYzA0YzM=',
        name: 'legz - panel snapshots',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
    },
    scene: {
        id: 'c2NlbmU6NWQ4YzUxNWIzNWJmMjcwZmVlODUwYjQw',
        name: 'Scene 4',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                children: null,
                id: '1',
                name: 'Emoji Cloud',
                type: 'wordCloud',
                css: null,
                js: null,
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: false,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {},
                    postVersion: 1,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    minFontSize: 59,
                    maxFontSize: 119,
                    showSentiment: false,
                    spacing: 1,
                    blacklist: [],
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                        baseline: {
                            minFontSize: 70,
                            maxFontSize: 150,
                            spacing: 20,
                        },
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                },
                userAssetContentUrl: null,
                postRequests: null,
                classes: null,
                theme: {
                    colorFont: null,
                    colorPrimary: '',
                    colorSecondary: '#ff6060',
                    colorBackground: '',
                    colorNegative: '',
                    colorPostive: '',
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    fontFamilyPrimary: '',
                    fontFamilySecondary: '',
                    fontSizePrimary: '',
                    fontSizeSecondary: null,
                    fontPrimary: null,
                    fontSecondary: null,
                    backgroundImage: {
                        url: '',
                        previewUrl: null,
                        samId: null,
                        name: null,
                        description: null,
                        backgroundRepeat: null,
                        backgroundSize: null,
                    },
                    typography: {
                        color: '',
                        size: null,
                        sizeLiteral: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        solid: '',
                        highlight: null,
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        ranked: {
                            colors: null,
                            contrast: null,
                        },
                    },
                },
                position: {
                    left: '0',
                    right: null,
                    top: '0',
                    bottom: null,
                    width: '100%',
                    height: '100%',
                    portrait: null,
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                analyticsRequests: [
                    {
                        includeTotal: null,
                        additional: {
                            TARGET_LANG_CODE: 'en',
                            Currency: null,
                            slaConfig: null,
                        },
                        reportingEngine: 'LISTENING',
                        report: 'SPRINKSIGHTS',
                        limit: 25,
                        sorts: [
                            {
                                heading: 'Mentions',
                                order: 'DESC',
                            },
                            {
                                heading: 'Emoticon',
                                order: 'ASC',
                            },
                        ],
                        timePeriods: [
                            {
                                startTime: 1568962800000,
                                endTime: 1569567599999,
                                timeZone: 'America/Los_Angeles',
                                key: 'last_7_days',
                                duration: 86400000,
                                previousPeriod: false,
                                wholePeriods: false,
                                xValue: null,
                            },
                        ],
                        groupBys: [
                            {
                                heading: 'Emoticon',
                                dimensionName: 'EMOTICONS',
                                groupType: 'FIELD',
                                details: null,
                            },
                        ],
                        filters: [
                            {
                                dimensionName: 'TOPIC_GROUP_IDS',
                                filterType: 'IN',
                                values: ['5a04774ce4b07f3ea5fd383e'],
                                details: null,
                            },
                        ],
                        projections: [
                            {
                                heading: 'Mentions',
                                measurementName: 'MENTIONS_COUNT',
                                aggregateFunction: 'SUM',
                                details: {
                                    origOrder: 0,
                                },
                            },
                        ],
                    },
                ],
                analyticsResults: [
                    {
                        dataSets: [
                            {
                                metrics: [
                                    {
                                        name: 'Mentions',
                                        type: 'NUMBER',
                                        aggregateFunction: 'SUM',
                                    },
                                ],
                                dimensions: [
                                    {
                                        name: 'Emoticon',
                                        type: 'STRING',
                                    },
                                ],
                                rows: [
                                    ['❤', 67],
                                    ['🇬🇧', 41],
                                    ['☎', 40],
                                    ['©', 37],
                                    ['🚀', 37],
                                    ['💯', 32],
                                    ['💨', 26],
                                    ['🙏', 26],
                                    ['📦', 25],
                                    ['📲', 24],
                                    ['🔥', 23],
                                    ['🚨', 23],
                                    ['😍', 22],
                                    ['🏍', 20],
                                    ['🚛', 19],
                                    ['™', 16],
                                    ['®', 13],
                                    ['⬇', 12],
                                    ['🇧🇷', 12],
                                    ['👻', 12],
                                    ['💣', 12],
                                    ['✨', 11],
                                    ['💳', 10],
                                    ['⚠', 9],
                                    ['💰', 9],
                                ],
                            },
                        ],
                    },
                ],
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Emoji Cloud',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 20,
                },
            },
        ],
        id: '1',
        name: null,
        type: null,
        css: null,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: false,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_wordcloud',
        theme: {
            colorFont: null,
            colorPrimary: '',
            colorSecondary: '#ff6060',
            colorBackground: '',
            colorNegative: '',
            colorPostive: '',
            ext: {
                padding: 40,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            fontFamilyPrimary: '',
            fontFamilySecondary: '',
            fontSizePrimary: '',
            fontSizeSecondary: null,
            fontPrimary: null,
            fontSecondary: null,
            backgroundImage: {
                url: '',
                previewUrl: null,
                samId: null,
                name: null,
                description: null,
                backgroundRepeat: null,
                backgroundSize: null,
            },
            typography: {
                color: '',
                size: null,
                sizeLiteral: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                solid: '',
                highlight: null,
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                ranked: {
                    colors: null,
                    contrast: null,
                },
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Header',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1569482459986,
};
export default emojiCloudSnapshot;
